const internationalization = {
  "locales": [
    "en",
    "pt"
  ],
  "requiredLocales": [
    "en",
    "pt"
  ],
  "strictMode": "inclusive",
  "defaultLocale": "pt"
};
const routing = {
  "mode": "prefix-no-default",
  "storage": {
    "cookies": [
      {
        "name": "INTLAYER_LOCALE",
        "attributes": {
          "path": "/"
        }
      }
    ],
    "headers": [
      {
        "name": "x-intlayer-locale"
      }
    ]
  },
  "basePath": ""
};
const editor = {
  "editorURL": "http://localhost:8000",
  "cmsURL": "https://app.intlayer.org",
  "backendURL": "https://back.intlayer.org",
  "port": 8000,
  "enabled": false,
  "dictionaryPriorityStrategy": "local_first",
  "liveSync": false,
  "liveSyncPort": 4000,
  "liveSyncURL": "http://localhost:4000"
};
const log = {
  "mode": "default",
  "prefix": "\u001b[38;5;239m[intlayer] \u001b[0m"
};
const system = {
  "baseDir": "/repo/apps/nina-spa",
  "moduleAugmentationDir": "/repo/apps/nina-spa/.intlayer/types",
  "unmergedDictionariesDir": "/repo/apps/nina-spa/.intlayer/unmerged_dictionary",
  "remoteDictionariesDir": "/repo/apps/nina-spa/.intlayer/remote_dictionary",
  "dictionariesDir": "/repo/apps/nina-spa/.intlayer/dictionary",
  "dynamicDictionariesDir": "/repo/apps/nina-spa/.intlayer/dynamic_dictionary",
  "fetchDictionariesDir": "/repo/apps/nina-spa/.intlayer/fetch_dictionary",
  "typesDir": "/repo/apps/nina-spa/.intlayer/types",
  "mainDir": "/repo/apps/nina-spa/.intlayer/main",
  "configDir": "/repo/apps/nina-spa/.intlayer/config",
  "cacheDir": "/repo/apps/nina-spa/.intlayer/cache",
  "tempDir": "/repo/apps/nina-spa/.intlayer/tmp"
};
const content = {
  "fileExtensions": [
    ".content.ts",
    ".content.js",
    ".content.cjs",
    ".content.mjs",
    ".content.json",
    ".content.json5",
    ".content.jsonc",
    ".content.tsx",
    ".content.jsx",
    ".content.md",
    ".content.mdx",
    ".content.yaml",
    ".content.yml"
  ],
  "contentDir": [
    "/repo/apps/nina-spa"
  ],
  "codeDir": [
    "/repo/apps/nina-spa"
  ],
  "excludedPath": [
    "**/node_modules/**",
    "**/dist/**",
    "**/build/**",
    "**/.intlayer/**",
    "**/.next/**",
    "**/.nuxt/**",
    "**/.expo/**",
    "**/.vercel/**",
    "**/.turbo/**",
    "**/.tanstack/**",
    "**/.output/**",
    "**/.svelte-kit/**"
  ],
  "watch": true
};
const ai = {};
const dictionary = {
  "fill": true,
  "contentAutoTransformation": false,
  "location": "local",
  "importMode": "static"
};
const build = {
  "mode": "auto",
  "minify": false,
  "purge": false,
  "traversePattern": [
    "**/*.{tsx,ts,js,mjs,cjs,jsx,vue,svelte,astro}",
    "!**/node_modules/**",
    "!**/dist/**",
    "!**/build/**",
    "!**/.intlayer/**",
    "!**/.next/**",
    "!**/.nuxt/**",
    "!**/.expo/**",
    "!**/.vercel/**",
    "!**/.turbo/**",
    "!**/.tanstack/**",
    "!**/.output/**",
    "!**/.svelte-kit/**",
    "!**/*.config.*",
    "!**/*.test.*",
    "!**/*.spec.*",
    "!**/*.stories.*",
    "!**/*.d.ts",
    "!**/*.d.ts.map",
    "!**/*.map"
  ],
  "outputFormat": [
    "esm",
    "cjs"
  ],
  "cache": true,
  "checkTypes": false
};
const compiler = {
  "enabled": true,
  "dictionaryKeyPrefix": "",
  "noMetadata": false,
  "saveComponents": false
};

export { internationalization, routing, editor, log, system, content, ai, dictionary, build, compiler };
